<template>
	<div>
		<div class="panel-list-tab" @click="toggleOpen">
			<p class="panel-list-item">{{ questionGroup.name }}</p>
			<span
				class="icon"
			><i class="fas" :class="open ? 'fa-angle-down' : 'fa-angle-up'"></i
			></span>
		</div>
		<div
			class="panel-list narrow no-hover"
			v-for="question in questions"
			:key="question.id"
		>
			<p class="panel-list-item">{{ question.name }}</p>
			<span class="icon" @click="removeQuestion(question)">
				<i class="fas fa-minus"></i>
			</span>
		</div>
	</div>
</template>

<script>

export default {
	props: {
		questionGroup: Object
	},
	data() {
		return {
			open: true
		};
	},
	computed: {
		questions() {
			return this.open ? this.questionGroup.questions : [];
		}
	},
	methods: {
		toggleOpen() {
			this.open = !this.open;
		},
		removeQuestion(question) {
			this.$emit('removeQuestion', question);
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/colors.scss";

.panel-list-tab {
  cursor: pointer;
  position: relative;
  display: inline-block;
  background: $lightest-grey;
  border-bottom: 1px solid $light-grey;
  font-weight: 600;
  padding: 10px;
  padding-right: 40px;
  margin-left: 10px;
  &:only-child {
    margin-bottom: 20px;
  }
  .icon {
    font-size: 24px;
    position: absolute;
    right: 10px;
    bottom: 10px;
    cursor: pointer;
    &:hover i {
      color: $info;
    }
  }
}
</style>
